import { useState, useEffect } from "react";
import { toast } from "sonner";
import { providerService } from "../services/provider.service";

let cache = null;

export function useActiveProvider() {
  const [providers, setProviders] = useState(cache ?? []);
  const [loading, setLoading] = useState(cache === null);

  useEffect(() => {
    if (cache !== null) return;
    providerService.getProviders()
      .then(data => {
        cache = data;
        setProviders(data);
        setLoading(false);
      })
      .catch(err => {
        toast.error(err?.response?.data?.detail || "Erro ao carregar providers.");
        setLoading(false);
      });
  }, []);

  const activeProvider = providers.find(p => p.is_active) ?? null;

  return { providers, activeProvider, loading };
}
